import { render, staticRenderFns } from "./AddressListLeft.vue?vue&type=template&id=608d463a&scoped=true&"
import script from "./AddressListLeft.vue?vue&type=script&lang=js&"
export * from "./AddressListLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608d463a",
  null
  
)

export default component.exports